module.exports = __webpack_public_path__ + "71a41efef6e0f1de34edea8187e5a633.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/poster/quiz-poster.jpg
// module id = 295
// module chunks = 0